<template>
  <div class="d-flex flex-column mr-2">
    <p class="mb-1 caption blue-grey--text text--lighten-1">
      {{ role }}
    </p>

    <div class="d-flex mt-1">
      <v-badge
        v-if="inactive"
        dot
        color="amber"
        class="pt-3"
        style="z-index: 7;"
      ></v-badge>
      <ChipAvatar
        backgroundColor="transparent"
        borderColor="transparent"
        textColor="blue-grey lighten-2"
        small
        :account="account"
        :vuetifyProps="{ close: editable }"
        @click:close="$emit('click:close')"
      />
    </div>
  </div>
</template>

<script>
import ChipAvatar from '@/components/ChipAvatar.vue'

export default {
  name: 'TeamMember',

  components: { ChipAvatar },

  props: {
    account: {
      type: Object,
      required: true,
    },
    userId: {
      type: String,
      required: false,
    },
    organizationId: {
      type: String,
      required: false,
    },
    role: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    inactive: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    blackFont: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
